<onyx-modal
  variant="center"
  [heading]="`${I18N}.editEmployee`"
  [close$]="close$"
  (closeModal)="dialogRef.close()"
>
  <form [formGroup]="form" [onyxAutoFocus]="true">
    @let controls = form.controls;
    <div class="group">
      <onyx-text-field
        [formControl]="controls.firstName"
        label="labels.firstName"
        textTransform="titlecase"
      ></onyx-text-field>

      <onyx-text-field
        [formControl]="controls.lastName"
        label="labels.lastName"
        textTransform="titlecase"
      ></onyx-text-field>
    </div>

    <div class="group">
      <onyx-phone-number-input
        [formControl]="controls.phone"
        label="labels.phone"
      ></onyx-phone-number-input>

      <onyx-text-field
        [formControl]="controls.email"
        label="labels.email"
        autocomplete="email"
        textTransform="lowercase"
      ></onyx-text-field>
    </div>

    <app-employee-roles-dropdown
      [control]="controls.roles"
    ></app-employee-roles-dropdown>
  </form>

  <onyx-button
    bottomLeftOptions
    color="red"
    variant="outlined"
    (click)="archiveEmployee()"
  >
    {{ 'labels.archive' | translate }}
  </onyx-button>

  <ng-container bottomRightOptions>
    <onyx-button variant="outlined" (click)="close$.next()">
      {{ 'labels.cancel' | translate }}
    </onyx-button>

    <onyx-button [spinner]="loading()" (click)="!loading() ? submit() : null">
      {{ 'labels.save' | translate }}
    </onyx-button>
  </ng-container>
</onyx-modal>
